import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/forgings-reporting')({
  component: Outlet,
  staticData: {
    title: 'Forgings Reporting',
    layout: { enableScrolling: true, showSearchBar: false },
  },
})
